import interviewPlannerService from '../../../../../../services/interviewPlanner';

async function interviewPlannerFetcher(reportReferenceId: string) {
  // TODO: Replace this with actual API call
  return interviewPlannerService.fetchInterviewQuestions(reportReferenceId);
}

export default interviewPlannerFetcher;
